import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import { isMoment } from 'moment';
import { AuthContext } from 'context/AuthProvider';
import { EmailVerificationContext } from 'context/EmailVerificationProvider';
import { GlobalContext } from 'context/GlobalProvider';
import Spinner from 'components/Spinner/Spinner';
import SignInForm from 'components/AuthForms/SignInForm';
import { CONNECT_FLOW, REQUEST_FLOW } from './MembershipsWizard';
import { setStateToUrl } from 'library/helpers/url_handler';
import {
  FormWrapper,
  Title,
  SubTitle,
  GuestLinkWrapper
} from './MembershipsWizard.style.js';
import { getFormattedSourcePath } from 'library/helpers/amplitude';
import useAmplitude from 'library/hooks/useAmplitude';
import {URL_DATE_FORMAT} from "../../../library/helpers/utils";

const WizardSignIn = ({
  onSignUpAuth,
  flow,
  date,
  match,
  history,
  location,
  onCloseDrawer,
  selectedMarina,
  onGuestFlow = () => {}
}) => {
  const { t } = useTranslation();
  const {
    signInFacebookAccount,
    signInGoogleAccount,
    signIn,
    loggedIn,
    waitForUserLoggedIn
  } = useContext(AuthContext);
  const { getSingleMarina } = useContext(GlobalContext);
  const { onVerify } = useContext(EmailVerificationContext);
  const currentMarina = getSingleMarina(selectedMarina || match.params.id);
  const [state, setState] = useState({
    facebookBtnLoading: false,
    googleBtnLoading: false
  });
  const [error, setError] = useState('');
  const [isAuthProcess, setIsAuthProcess] = useState(false);
  const { sendToAmplitude } = useAmplitude();

  const goToReservation = user => {
    onCloseDrawer();
    setTimeout(() => {
      // workaround: fix the strange bug from ant design
      // in some reason body gets overflow:hidden after popup closing:
      // https://github.com/ant-design/ant-design/issues/21539
      document.body.style.overflow = '';
      document.body.style.position = 'static';
      document.body.style.top = 'auto';
    }, 500);
    const date_range = {
      setStartDate: isMoment(date.setStartDate)
        ? date.setStartDate.format(URL_DATE_FORMAT)
        : date.setStartDate,
      setEndDate: isMoment(date.setEndDate)
        ? date.setEndDate.format(URL_DATE_FORMAT)
        : date.setEndDate
    };
    if (!user.emailVerified) {
      onVerify({
        force: true,
        additionalSearch: setStateToUrl({ date_range }),
        currentUser: user
      });
    }

    history.push({
      pathname: location.pathname,
      search: setStateToUrl({ date_range })
    });
  };

  const facebookAuthAction = async () => {
    setState({ facebookBtnLoading: true });
    setIsAuthProcess(true);
    const boater = await signInFacebookAccount({ onError: console.log });
    await waitForUserLoggedIn();

    if (flow === 'RESERVATION') {
      goToReservation(boater);
    }
    setState({ facebookBtnLoading: false });
    setIsAuthProcess(false);

    //Amplitude event
    const source = getFormattedSourcePath({ source: flow });
    sendToAmplitude({
      identificationData: { boater },
      eventProperties: { source },
      eventName: 'login'
    });
  };

  const googleAuthAction = async () => {
    setState({ googleBtnLoading: true });
    setIsAuthProcess(true);
    const boater = await signInGoogleAccount({ onError: console.log });
    await waitForUserLoggedIn();

    if (flow === 'RESERVATION') {
      goToReservation(boater);
    }
    setState({ googleBtnLoading: false });
    setIsAuthProcess(false);

    //Amplitude event
    const source = getFormattedSourcePath({ source: flow });
    sendToAmplitude({
      identificationData: { boater },
      eventProperties: { source },
      eventName: 'login'
    });
  };

  const handleSubmit = async formProps => {
    if (!loggedIn) {
      setIsAuthProcess(true);
      try {
        const boater = await signIn({ ...formProps, onError: setError });
        await waitForUserLoggedIn();

        if (flow === 'RESERVATION') {
          goToReservation(boater.user);
        }
        //Amplitude event
        const source = getFormattedSourcePath({ source: flow });
        sendToAmplitude({
          identificationData: { boater },
          eventProperties: { source },
          eventName: 'login'
        });
      } catch (error) {
        setIsAuthProcess(false);
      }
    }
  };

  return (
    <FormWrapper className={flow === 'RESERVATION' ? 'reservation-flow' : ''}>
      {flow === 'RESERVATION' &&
        !currentMarina?.marina_settings?.permissions?.disable_guest_reservations &&
        !currentMarina.marina_settings.instant_booking && (
          <GuestLinkWrapper>
            <Link
              to={'#'}
              className='guest-continue-link'
              onClick={e => {
                e.preventDefault();
                onGuestFlow();
              }}
            >
              {t('CONTINUE_AS_GUEST')}
            </Link>
          </GuestLinkWrapper>
        )}
      <Title>{t('SIGN_IN_TITLE')}</Title>
      {flow === REQUEST_FLOW && (
        <SubTitle>{t('SIGN_IN_TO_REQUEST_CARD_FOR_RESERVATION_TO')} </SubTitle>
      )}
      {flow === CONNECT_FLOW && (
        <SubTitle>{t('SIGN_IN_TO_CONNECT_CARD_WITH_RESERVATION_TO')} </SubTitle>
      )}
      {flow === 'RESERVATION' && (
        <SubTitle>{t('SIGN_IN_TO_CONTINUE_RESERVATION_TO')} </SubTitle>
      )}
      <SignInForm
        handleSubmit={handleSubmit}
        error={error}
        googleBtnLoading={state.googleBtnLoading}
        googleAuthAction={googleAuthAction}
        facebookBtnLoading={state.facebookBtnLoading}
        facebookAuthAction={facebookAuthAction}
        onSignUpLinkClick={e => {
          e.preventDefault();
          onSignUpAuth();
        }}
      />
      <Spinner spinning={isAuthProcess} tip={t('SIGNING_IN_SPINNER_TEXT')} />
    </FormWrapper>
  );
};

export default withRouter(WizardSignIn);
